module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rightContent",
    staticStyle: {
      "overflow": "auto",
      "display": "flex",
      "flex-direction": "column",
      "height": "100%",
      "z-index": "1000"
    }
  }, [_c('secondtop', {
    attrs: {
      "caseInfo": _vm.caseInfo
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row",
      "align-items": "stretch",
      "flex-grow": "1"
    }
  }, [_c('secondmenu', {}), _vm._v(" "), _c('router-view', {
    staticClass: "right-content",
    staticStyle: {
      "position": "fixed",
      "top": "128px",
      "left": "390px",
      "right": "0",
      "bottom": "0",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    },
    attrs: {
      "caseInfo": _vm.caseInfo
    },
    on: {
      "renewData": _vm.getUserInfo
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c9f8415!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cases.vue
// module id = 992
// module chunks = 2